var _line, _path, _line2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMobileArrowLineLearning = function SvgMobileArrowLineLearning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 27,
    viewBox: "0 0 260 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.991211,
    y1: 15.65,
    x2: 230.679,
    y2: 15.65,
    stroke: "#C0C2C3",
    strokeWidth: 0.7,
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5752 15.25L12.462 20.6627L12.462 9.83734L19.5752 15.25Z",
    fill: "#664CFF"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.833,
    y1: 15.5419,
    x2: 259.526,
    y2: 15.5419,
    stroke: "#664CFF",
    strokeWidth: 0.91625
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobileArrowLineLearning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MobileArrowLineLearning.c3d0f00e.svg";
export { ForwardRef as ReactComponent };